import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=380a6dde&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"
import style0 from "./Notes.vue?vue&type=style&index=0&id=380a6dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a6dde",
  null
  
)

export default component.exports